var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"small":""}},[_c('v-avatar',[_c('img',{attrs:{"src":_vm.datos[_vm.empresa].avatar}})]),_vm._v("\n    "+_vm._s(_vm.datos[_vm.empresa].name)+"\n")],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8c4ced0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/EmpresaChip.vue
// module id = b7zO
// module chunks = 0